jQuery(document).ready(function ($) {

    $(document).ajaxComplete(function () {
        // fix no result for search autocomplete
        if ($('[data-drupal-selector="edit-q"]:visible').length) {
            if ($('.ui-widget-content.ui-autocomplete li').length == 0) {
                $('[data-drupal-selector="product-search-form"] .no-results').fadeIn();
            } else {
                $('[data-drupal-selector="product-search-form"] .no-results').removeAttr('style');
            }
        }
    });

    var lastScrollTop = 0;
    var header = $('.header');

    $(window).scroll(function(event){
        var scrollTop = $(this).scrollTop();

        if (scrollTop > lastScrollTop){
            header.css('opacity', 0);
        } else {
            header.css('opacity', 1);
        }

        lastScrollTop = scrollTop;
    });

    // Menu < tablet
    if ($(document).innerWidth() < 991) {
        $('.burger-menu').on('click', function (e) {
            e.preventDefault();
            $('body').toggleClass('menu-open');
        });
    }

    // Menu hover
    if ($(document).innerWidth() > 991) {
        $('.menu').hover(function () {
            $('header.header').addClass('menu-hover');
        }, function () {
            $('header.header').removeClass('menu-hover');
        });
    }

    // Search
    if ($(document).innerWidth() > 991) {
        $('header .search').hover(function () {
            $('header .search-form').addClass('search-hover');
        }, function () {
            $('header .search-form').removeClass('search-hover');
        });
    }

    $('.timeline__slider').slick({
        autoplay: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        arrows: false,
        dots: false,
    });

    $('.timeline__decades').slick({
        autoplay: false,
        infinite: false,
        slidesToShow: 10,
        slidesToScroll: 1,
        cssEase: 'linear',
        arrows: false,
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1550,
                settings: {
                    slidesToShow: 6
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 4
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });

    $('.timeline__decade').click(function (event) {
        event.preventDefault();

        var slideDecade = $(this).data('slide-decade');
        var isSelected = $(this).hasClass('timeline__decade--selected');

        if (!isSelected) {
            $(this).siblings().removeClass('timeline__decade--selected').end().addClass('timeline__decade--selected');
            var activeSlideQuery = ".timeline__slider .timeline-item[data-slide-decade='" + slideDecade + "']";
            var firstSlideIndex = $(activeSlideQuery).first().data('slick-index');

            $('.timeline__slider').slick('slickGoTo', firstSlideIndex, false);
        }
    });

    function toggleTimelineDecadeSelected (direction) {

        var decadeCurrent = $('.timeline__decades .timeline__decade--selected').first().data('slide-decade');

        if (direction == 1) {
            $('.timeline__slider').slick('slickNext');
        } else {
            $('.timeline__slider').slick('slickPrev');
        }

        var currentSlideDecade = $('.timeline__slider .slick-active').data('slide-decade');

        if (decadeCurrent != currentSlideDecade) {

            var activeSlideQuery = ".timeline__decades .timeline__decade[data-slide-decade='" + currentSlideDecade + "']";
            $(activeSlideQuery).siblings().removeClass('timeline__decade--selected').end().addClass('timeline__decade--selected');
            var slideIndex = $(activeSlideQuery).data('slick-index');
            $('.timeline__decades').slick('slickGoTo', slideIndex, false);
        }
    }

    $('.timeline__nav .prev').click(function () {
        toggleTimelineDecadeSelected(-1);

        ga_track('slider', 'click', 'timeline previous');
    });

    $('.timeline__nav .next').click(function () {
        toggleTimelineDecadeSelected(1);

        ga_track('slider', 'click', 'timeline next');
    });

    $('.testimonials__slider').slick({
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        arrows: true,
        dots: false,
        prevArrow: '.testimonials__nav .prev',
        nextArrow: '.testimonials__nav .next',
    });

    $('.testimonials__nav .prev').click(function () {
        ga_track('slider', 'click', 'testimonial previous');
    });

    $('.testimonials__nav .next').click(function () {
        ga_track('slider', 'click', 'testimonial next');
    });

    $('.find-attachment__slider').slick({
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        arrows: true,
        dots: false,
        prevArrow: '.find-attachment__nav .prev',
        nextArrow: '.find-attachment__nav .next',
    });

    $('.find-attachment__nav .prev').click(function () {
        ga_track('slider', 'click', 'find an attachment previous');
    });

    $('.find-attachment__nav .next').click(function () {
        ga_track('slider', 'click', 'find an attachment next');
    });

    // Homepage
    if ($('body').hasClass('page-node-type-homepage')) {

        // Home scroll
        if ($(document).innerWidth() > 991) {
            $.scrollify({
                section: ".page-scrollify",
                easing: "swing",
                scrollSpeed: 1000,
            });
        }

        // Home slider main
        $('.home .slider-main').slick({
            autoplay: true,
            autoplaySpeed: 6000,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'linear',
            arrows: true,
            dots: true,
            prevArrow: '.slider-main .nav-slider .prev',
            nextArrow: '.slider-main .nav-slider .next',
        });

        $('.main-visual .nav-slider .prev').on('click', function (e) {
            e.preventDefault();
            $(".home .slider-main").slick('slickPrev');
        });

        $('.main-visual .nav-slider .next').on('click', function (e) {
            e.preventDefault();
            $(".home .slider-main").slick('slickNext');
        });


        // Home slider
        var slideControls = $('.home .slider .slider-controls');
        $('.home .slider .slider-content-0').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            initialSlide: 1,
            arrows: true,
            dots: true,
            appendArrows: slideControls,
            prevArrow: '.slider .nav-slider .prev',
            nextArrow: '.slider .nav-slider .next',
            appendDots: slideControls,
            draggable: true,
            swipeToSlide: true
        });

        $(".home .slider .slider-content-1").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            arrows: false,
            initialSlide: 3,
            draggable: false,
        });

        $(".home .slider .slider-content-2").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            arrows: false,
            initialSlide: 2,
            draggable: false,
        });

        $('.home .slide-titles').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            fade: true,
            arrows: false,
            initialSlide: 1,
            draggable: false,
        });

        $('.home .slide-titles-2').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            fade: true,
            arrows: false,
            initialSlide: 2,
            draggable: false,
        });

        $('.home .slide-links').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            fade: true,
            arrows: false,
            draggable: false,
            initialSlide: 1,
        });

        $('.slider .nav-slider .prev').on('click', function (e) {
            e.preventDefault();
            navSlider('right');

        });

        $('.slider .nav-slider .next').on('click', function (e) {
            e.preventDefault();
            navSlider('left');

        });

        $(".home .slider .slider-content-0").off('swipe').on('swipe', function (event, slick, direction) {
            event.preventDefault();
            navSlider(direction);
        });

        function navSlider(direction, index) {
            if (direction == 'left') {
                $(".home .slider .slider-content-1").slick('slickNext');
                $(".home .slider .slider-content-2").slick('slickNext');
                $(".home .slider .slide-titles").slick('slickNext');
                $(".home .slider .slide-titles-2").slick('slickNext');
                $(".home .slider .slide-links").slick('slickNext');
                $(".slide-nav").slick('slickNext');
            } else {
                $(".home .slider .slider-content-1").slick('slickPrev');
                $(".home .slider .slider-content-2").slick('slickPrev');
                $(".home .slider .slide-titles").slick('slickPrev');
                $(".home .slider .slide-titles-2").slick('slickPrev');
                $(".home .slider .slide-links").slick('slickPrev');
                $(".slide-nav").slick('slickPrev');
            }
        }


        // Home listing - hover
        function homeLinstingShow() {
            if ($('.listing-home:in-viewport').length > 0) {
                setTimeout(function () {
                    $('.home .listing-home').addClass('show');
                }, 500);
            }
        }

        homeLinstingShow();
        $(window).scroll(function (e) {
            homeLinstingShow();
        });

        $('.home .titles a').hover(function () {
            var refTitle = $(this).attr('class');
            $('.home .titles a').addClass('hover');
            $('.home .listing-images .image.' + refTitle).addClass('hover');
        }, function () {
            $('.home .titles a').removeClass('hover');
            $('.home .listing-images .image').removeClass('hover');
        });

    }

    // Home short content
    function fadeSectionOnViewport() {
        $('.animated:in-viewport').addClass('fadeInUp');
    }

    fadeSectionOnViewport();
    $(window).scroll(function (e) {
        fadeSectionOnViewport();
    });


    // Calcul nbr d'elements pour la liste marché
    if ($('.card-item-marche-x5').length == 4) {
        $('.card-item-marche-x5').css("width", "25%");
    }


    if ($('footer .menu-item--plus') && $('footer .menu-item--plus').length > 0) {
        $('footer .menu-item--plus').on('click', function () {
            $(this).hide('slow');
            $(this).parent('ul').children('.menu-item--hidden').show('slow');
        })
    }

    // Effect accordion
    $(document).on('click', '.btn-collapse, [data-target="#desc-see-more"]', function (e) {
        e.preventDefault();
        if (!$(this).closest('.group').hasClass('active')) {
            $('.group').removeClass('active');
            $(this).closest('.group').addClass('active');
        } else {
            $(this).closest('.group').removeClass('active');
        }
        return false;
    });


    if ($('.form-checkbox') && $('.form-checkbox').length > 0) {
        $('.form-checkbox').on('change', function () {
            if ($(this).is(':checked')) {
                $(this).parent().children('label').addClass('checked');
            } else {
                $(this).parent().children('label').removeClass('checked');
            }
        })
    }

    // Lecteur vidéo
    var video_id = $('#player').attr('data-id');
    var mute = false,
        controls = 1;
    if($('body').hasClass('path-frontpage')) {
       mute = true;
       controls = 0;
    }
    $('#player').YTPlayer({
        fitToBackground: true,
        videoId: video_id,
        mute: mute,
        pauseOnScroll: false,
        playerVars: {
            modestbranding: 0,
            autoplay: 1,
            controls: controls,
            showinfo: 0,
            wmode: 'transparent',
            branding: 0,
            rel: 0,
            autohide: 0,
            origin: window.location.origin
        }
    });



    // open popup phone desktop
    $(document).on('click', 'a[href^="tel:"].phone:not(.open)', function () {
        if (window.matchMedia("(min-width: 576px)").matches) {
            $(this).next('.js-phonedesk').addClass('show');
            $(this).addClass('open');
            return false;
        }
    });
    $(document).on('click','a[href^="tel:"].phone.open, .js-phonedesk .js-close, .js-phonedesk.show', function(){
        if(window.matchMedia("(min-width: 576px)").matches) {
            $('.js-phonedesk').removeClass('show');
            $('a[href^="tel:"].phone').removeClass('open');
            return false;
        }
    });

    // paragraph - equipment_hover_block
    $('.equipment_hover_block__item').hover(
        function () {

            var hoverItemID = $(this).data('key');

            var activeBGQuery = ".equipment_hover_block__bg[data-key='" + hoverItemID + "']";
            $(activeBGQuery).siblings().removeClass('equipment_hover_block__bg--active').end().addClass('equipment_hover_block__bg--active');
        },
        function () {
            $('.equipment_hover_block__bg').removeClass('equipment_hover_block__bg--active');
        }
    );


    // Cookie added btn.
    $(document).on('click', '.eu-cookie-compliance-reject-all', function(){
        $('.eu-cookie-compliance-category').each(function() {
            var value = $(this).find('input').val();
            if (value !== "mandatory") {
                $(this).find('input')[0].checked = false;
            }
        });
        $('.eu-cookie-compliance-save-preferences-button').trigger('click');
        return false;
    });

});
